var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2479 16.489V12.7922H6.75287C6.81164 14.1218 7.01684 15.3702 7.33547 16.489H11.2479Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2479 18.0734H7.89844C8.05054 18.4232 8.21507 18.7532 8.39051 19.0612C9.20963 20.4992 10.2125 21.3787 11.2479 21.6661V18.0734Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77232 16.489C5.48114 15.3385 5.29982 14.093 5.24722 12.7922H2C2.09248 14.1059 2.41311 15.3528 2.9203 16.489H5.77232Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79474 18.0734H6.2647C6.5065 18.7209 6.78665 19.325 7.1007 19.8763C7.57025 20.7006 8.12938 21.4271 8.76305 22C6.73745 21.2727 5.00347 19.8818 3.79474 18.0734Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7521 18.0734H16.1016C15.9495 18.4232 15.785 18.7532 15.6095 19.0612C14.7904 20.4992 13.7875 21.3787 12.7521 21.6661V18.0734Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6646 16.489H12.7521V12.7922H17.2472C17.1884 14.1218 16.9832 15.3702 16.6646 16.489Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7353 18.0734C17.4935 18.7209 17.2134 19.325 16.8993 19.8763C16.4298 20.7006 15.8707 21.4271 15.237 22C17.2626 21.2727 18.9966 19.8818 20.2053 18.0734H17.7353Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0797 16.489H18.2277C18.5189 15.3385 18.7002 14.093 18.7528 12.7922H22C21.9075 14.1059 21.5869 15.3528 21.0797 16.489Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7521 11.2078V7.51099H16.6646C16.9832 8.62982 17.1884 9.87826 17.2472 11.2078H12.7521Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2479 11.2078V7.51099H7.33547C7.01684 8.62982 6.81164 9.87826 6.75287 11.2078H11.2479Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1016 5.92659H12.7521V2.33386C13.7875 2.62124 14.7904 3.50082 15.6095 4.9388C15.785 5.2468 15.9495 5.5768 16.1016 5.92659Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7528 11.2078C18.7002 9.90704 18.5189 8.66147 18.2277 7.51099H21.0797C21.5869 8.64719 21.9075 9.89407 22 11.2078H18.7528Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7353 5.92662H20.2053C18.9966 4.11815 17.2626 2.72726 15.237 2C15.8707 2.57292 16.4298 3.29937 16.8993 4.12368C17.2134 4.67501 17.4935 5.27911 17.7353 5.92662Z",
    fill: "currentColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89844 5.92659H11.2479V2.33386C10.2125 2.62124 9.20963 3.50082 8.39051 4.9388C8.21507 5.2468 8.05054 5.5768 7.89844 5.92659Z",
    fill: "currentColor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1007 4.12368C6.78665 4.67501 6.5065 5.27911 6.2647 5.92662H3.79474C5.00347 4.11815 6.73745 2.72726 8.76306 2C8.12938 2.57292 7.57025 3.29937 7.1007 4.12368Z",
    fill: "currentColor"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.2078C2.09248 9.89407 2.41311 8.64719 2.9203 7.51099H5.77232C5.48114 8.66147 5.29982 9.90704 5.24722 11.2078H2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.41d0460497f72d6224d76aa42e447a23.svg";
export { ForwardRef as ReactComponent };